import * as React from "react";
import DocumentTitle from "react-document-title";
import Grid from "@material-ui/core/Grid";
import { observer } from "mobx-react-lite";
import { UserRoleEnum } from "../../static/enums/UserRole";
import { useGetUsers } from "../../helpers/hooks/useGetUsers";
import { uiStore } from "../../mobx/stores/UiStore/UiStore";
import { ContentMakersProfilesTable } from "../../features/Tables/ContentMakersProfilesTable/ContentMakersProfilesTable";

export const ContentMakersProfilesPage = observer(() => {
  const { loading } = uiStore;
  useGetUsers({
    role: UserRoleEnum.contenter,
  });

  return (
    <DocumentTitle title={"Создатели контента - Mindset.Digital"}>
      <Grid container spacing={3}>
        <ContentMakersProfilesTable loading={loading} />
      </Grid>
    </DocumentTitle>
  );
});
